export function asignacionMasivaEmpresaNormalize(row) {
    return {
        idAsignacionMasivaEmpresa: row.idAsignacionMasivaEmpresa ?? row.IdAsignacionMasivaEmpresa ?? 0,
        idCurso: row.idCurso ?? row.IdCurso ?? 0,
        idEmpresa: row.idEmpresa ?? row.IdEmpresa ?? 0,
        fechaLimite: row.fechaLimite ?? row.FechaLimite ?? null,
        activo: row.activo ?? row.Activo ?? false,
    };
}
